(() => {
  const LOADER_SELECTOR = '[data-hpf-thumbnail-loader]';
  const ROOT_SELECTOR = '[id^="HobbytechPartsFinder-"]';
  const DIAGRAM_01_KEY = 'complete-exploded-view';
  const DIAGRAM_01_OLD_SOURCE_FRAGMENT = 'promoto-mx-exploded-view-01';
  const DIAGRAM_01_SOURCE = 'https://cdn.shopify.com/s/files/1/0036/2115/8947/files/losi-promoto-mx-diagram-01-complete-exploded-view-v2_png.png?v=1785651683&hpf=20260802-1522';
  const SHAPE_CLASSES = [
    'hpf--hotspot-shape-circle',
    'hpf--hotspot-shape-rounded-square',
    'hpf--hotspot-shape-diamond'
  ];
  const MODEL_PRODUCTS = {
    LOS06000T1: {
      url: '/products/losi-promoto-mx-1-4-motorcycle-rtr-fxr-scheme',
      title: 'Losi Promoto-MX 1/4 Motorcycle RTR, FXR Scheme'
    },
    LOS06000T2: {
      url: '/products/losi-promoto-mx-1-4-motorcycle-rtr-clubmx-scheme',
      title: 'Losi Promoto-MX 1/4 Motorcycle RTR, ClubMX Scheme'
    },
    LOS06002: {
      url: '/products/losi-promoto-mx-1-4-motorcycle-rtr-combo-with-battery-and-charger-pro-circuit-scheme',
      title: 'Losi Promoto-MX 1/4 Motorcycle RTR Combo with Battery and Charger, Pro Circuit Scheme'
    }
  };

  function findPartsFinder(loader) {
    const loaderSection = loader.closest('.shopify-section');
    let sibling = loaderSection ? loaderSection.nextElementSibling : null;

    while (sibling) {
      const root = sibling.matches?.(ROOT_SELECTOR)
        ? sibling
        : sibling.querySelector?.(ROOT_SELECTOR);
      if (root) return root;
      sibling = sibling.nextElementSibling;
    }

    return document.querySelector(ROOT_SELECTOR);
  }

  function setVariable(root, name, value, unit = '') {
    if (value === undefined || value === null || value === '') return;
    root.style.setProperty(name, `${value}${unit}`);
  }

  function forceDiagram01Image(root) {
    const targets = new Set();
    const panel = root.querySelector(`[data-hpf-panel="${DIAGRAM_01_KEY}"]`);

    panel?.querySelectorAll('.hpf-viewer__image').forEach((image) => targets.add(image));

    root.querySelectorAll('.hpf-diagram-thumb__image').forEach((image) => {
      const source = `${image.getAttribute('src') || ''} ${image.getAttribute('srcset') || ''}`;
      if (source.includes(DIAGRAM_01_OLD_SOURCE_FRAGMENT) || image.alt === 'Complete Exploded View') {
        targets.add(image);
      }
    });

    targets.forEach((image) => {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.setAttribute('src', DIAGRAM_01_SOURCE);
      image.setAttribute('width', '1654');
      image.setAttribute('height', '2339');
      image.dataset.hpfImageOverride = 'diagram-01-v2';
    });
  }

  function linkCompatibleModels(root) {
    root.querySelectorAll('.hpf-model__number').forEach((item) => {
      const modelNumber = (item.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
      const modelProduct = MODEL_PRODUCTS[modelNumber];

      if (!modelProduct || item.matches('a')) return;

      const link = document.createElement('a');
      link.className = `${item.className} hpf-model__number--link`;
      link.href = modelProduct.url;
      link.setAttribute('aria-label', `View ${modelNumber} — ${modelProduct.title}`);
      link.innerHTML = `<span>${modelNumber}</span><span class="hpf-model__number-arrow" aria-hidden="true">→</span>`;
      item.replaceWith(link);
    });
  }

  function enhanceManualLink(root) {
    root.querySelectorAll('.hpf-model__actions a').forEach((link) => {
      const label = (link.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (label !== 'download manual' || link.dataset.hpfManualEnhanced === 'true') return;

      link.dataset.hpfManualEnhanced = 'true';
      link.classList.remove('hpf-model__text-link');
      link.classList.add('hpf-model__manual-button');
      link.setAttribute('aria-label', 'Download Manual');
      link.innerHTML = `
        <svg class="hpf-model__manual-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M6.75 3.75h7.5l3 3v13.5H6.75V3.75Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"></path>
          <path d="M14.25 3.75v3h3M9.25 11.5h5.5M9.25 15h5.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path>
        </svg>
        <span class="hpf-model__manual-copy">
          <strong>Download Manual</strong>
        </span>
        <span class="hpf-model__manual-arrow" aria-hidden="true">↗</span>
      `;
    });
  }

  function updateViewerHints(root) {
    root.querySelectorAll('.hpf-viewer__hint').forEach((hint) => {
      const icon = hint.querySelector('span');
      if (!icon) return;
      Array.from(hint.childNodes).forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) node.remove();
      });
      hint.append(' Tap a highlighted marker to view the matching part');
    });
  }

  function hideNotifyMeButtons(scope = document) {
    const elements = scope.matches?.('button, a')
      ? [scope]
      : Array.from(scope.querySelectorAll?.('button, a') || []);

    elements.forEach((element) => {
      if (element.dataset.hpfNotifyMeHidden === 'true') return;
      const label = (element.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (label !== 'notify me') return;

      element.dataset.hpfNotifyMeHidden = 'true';
      element.hidden = true;
      element.setAttribute('aria-hidden', 'true');
      element.style.setProperty('display', 'none', 'important');
    });
  }

  function startNotifyMeGuard() {
    if (!document.body || document.body.dataset.hpfNotifyMeGuard === 'true') return;

    document.body.dataset.hpfNotifyMeGuard = 'true';
    document.body.classList.add('hpf-parts-finder-preview-page');
    hideNotifyMeButtons(document);

    let scanScheduled = false;
    const queueScan = () => {
      if (scanScheduled) return;
      scanScheduled = true;
      requestAnimationFrame(() => {
        scanScheduled = false;
        hideNotifyMeButtons(document);
      });
    };

    const observer = new MutationObserver(queueScan);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function attachActiveState(root) {
    if (root.dataset.hpfAppearanceEvents === 'true') return;
    root.dataset.hpfAppearanceEvents = 'true';

    root.addEventListener('click', (event) => {
      const hotspot = event.target.closest('.hpf-hotspot[data-hpf-open-dialog]');
      if (!hotspot || !root.contains(hotspot)) return;

      root.querySelectorAll('.hpf-hotspot.is-active').forEach((item) => {
        item.classList.remove('is-active');
      });
      hotspot.classList.add('is-active');
    });

    root.querySelectorAll('.hpf-dialog').forEach((dialog) => {
      if (dialog.dataset.hpfAppearanceListener === 'true') return;
      dialog.dataset.hpfAppearanceListener = 'true';

      const panel = dialog.querySelector('.hpf-dialog__inner');

      dialog.addEventListener('click', (event) => {
        if (!dialog.open || !panel) return;

        const rect = panel.getBoundingClientRect();
        const outsidePanel =
          event.clientX < rect.left ||
          event.clientX > rect.right ||
          event.clientY < rect.top ||
          event.clientY > rect.bottom;

        if (outsidePanel) dialog.close();
      });

      dialog.addEventListener('close', () => {
        root.querySelectorAll('.hpf-hotspot.is-active').forEach((hotspot) => {
          if (hotspot.dataset.hpfOpenDialog === dialog.id) {
            hotspot.classList.remove('is-active');
          }
        });
      });
    });
  }

  function attachMobilePanGuard(root) {
    root.querySelectorAll('[data-hpf-viewport]').forEach((view) => {
      if (view.dataset.hpfMobilePanGuard === 'true') return;
      view.dataset.hpfMobilePanGuard = 'true';

      const preventPagePan = (event) => {
        if (view.classList.contains('is-zoomed') || event.touches.length > 1) {
          event.preventDefault();
        }
      };

      view.addEventListener('touchmove', preventPagePan, { passive: false });
    });
  }

  function applyAppearance(loader) {
    const root = findPartsFinder(loader);
    if (!root) return;

    forceDiagram01Image(root);
    linkCompatibleModels(root);
    enhanceManualLink(root);
    updateViewerHints(root);
    startNotifyMeGuard();

    const requestedShape = loader.dataset.hotspotShape || 'circle';
    const shape = ['circle', 'rounded-square', 'diamond'].includes(requestedShape)
      ? requestedShape
      : 'circle';

    root.classList.remove(...SHAPE_CLASSES);
    root.classList.add(`hpf--hotspot-shape-${shape}`);
    root.classList.toggle(
      'hpf--hotspot-pulse-disabled',
      loader.dataset.hotspotPulseEnabled !== 'true'
    );

    setVariable(root, '--hpf-dot-size-desktop', loader.dataset.hotspotSize, 'px');
    setVariable(root, '--hpf-dot-size-mobile', loader.dataset.hotspotSizeMobile, 'px');
    setVariable(root, '--hpf-hotspot-color', loader.dataset.hotspotColor);
    setVariable(root, '--hpf-hotspot-hover-color', loader.dataset.hotspotHoverColor);
    setVariable(root, '--hpf-hotspot-border-color', loader.dataset.hotspotBorderColor);
    setVariable(root, '--hpf-hotspot-border-width', loader.dataset.hotspotBorderWidth, 'px');
    setVariable(root, '--hpf-hotspot-pulse-color', loader.dataset.hotspotPulseColor);
    setVariable(root, '--hpf-hotspot-pulse-speed', loader.dataset.hotspotPulseSpeed, 's');
    setVariable(root, '--hpf-hotspot-label-bg', loader.dataset.hotspotLabelBg);
    setVariable(root, '--hpf-hotspot-label-text', loader.dataset.hotspotLabelText);
    setVariable(root, '--hpf-hotspot-label-size', loader.dataset.hotspotLabelSize, 'px');
    setVariable(root, '--hpf-hotspot-label-offset', loader.dataset.hotspotLabelOffset, 'px');

    attachActiveState(root);
    attachMobilePanGuard(root);
  }

  function scan(scope = document) {
    const loaders = scope.matches?.(LOADER_SELECTOR)
      ? [scope]
      : Array.from(scope.querySelectorAll?.(LOADER_SELECTOR) || []);

    loaders.forEach(applyAppearance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
